const paymentsEn = {
    payments: require('lang/en/payments/Payments').default,
};

export default paymentsEn;
